const MESES = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

export const formatArticleDate = (dateStr) => {
  const d = new Date(dateStr);
  return `${MESES[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
};
